import React, { Component } from 'react'
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap,playMainMusic} from './PlaySounds';
import {setGameScreenNumber,setScore,setTime,isArrayRandamized} from '../actions/commonActions';

class PauseScreen extends Component {

  resumePlay = () => {
        playButtonTap();
        this.props.setGameScreenNumber(this.props.oldScreenNumber,this.props.screenNumber);
      };
      goToMainMenu = () => {
        playButtonTap();
        this.props.setScore(0);
        this.props.setTime(200);
        this.props.isArrayRandamized(false);
        this.props.history.push('/mainmenu');
        playMainMusic();
      };
      restartPlay = () => {
        playButtonTap();
        this.props.setScore(0);
        this.props.setTime(200);
        this.props.isArrayRandamized(false);
        this.props.setGameScreenNumber(1,1);
      };
    

    render() {
      var pausedText = "";
      if(this.props.language === "en"){
        pausedText = "Paused";
      }else if(this.props.language === "ur"){
        pausedText = "رک گیا";
      }
            return(
                <div className = "screen_background">
                  <div className = "buttons_wrapper pause_buttons_wrapper">
                    <div className = "setting_title paused_title">
                      {pausedText}
                    </div>
                    <img src={"/game-skins/build-rev79-TUGQhb2Uf/images_"+this.props.language+"/btn_resume.png"} alt="" className="button home_button" onClick = {this.resumePlay}/><br/>
                    <img src={"/game-skins/build-rev79-TUGQhb2Uf/images_"+this.props.language+"/btn_main_menu.png"} alt="" className="button home_button" onClick = {this.goToMainMenu}/><br/>
                    <img src={"/game-skins/build-rev79-TUGQhb2Uf/images_"+this.props.language+"/btn_restart.png"} alt="" className="button home_button" onClick = {this.restartPlay}/><br/>
                  </div>
                  
                </div>
            )
    }
}

PauseScreen.propTypes = {
  language:PropTypes.string.isRequired,
  screenNumber:PropTypes.number.isRequired,
  oldScreenNumber:PropTypes.number.isRequired
}

const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  screenNumber:state.config.screenNumber,
  oldScreenNumber:state.config.oldScreenNumber
});

//export default connect(mapStateToProps,{setGameScreenNumber})(PauseScreen);
export default withRouter(connect(mapStateToProps,{setGameScreenNumber,setScore,setTime,isArrayRandamized})(PauseScreen));



// WEBPACK FOOTER //
// ./src/components/PauseScreen.js